import axios from "axios";

var getMeetingsWithDecisions = function getMeetingsWithDecisions(groupId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return axios.get("/groups/" + groupId + "/meetings-where-relation-exist?include=decisions:order(created_at|desc)&page=" + page);
};

var getMeetingDecisions = function getMeetingDecisions(groupId, meetingId) {
  return axios.get("/groups/" + groupId + "/meetings/" + meetingId + "/decisions?include=meeting");
};

var storeDecision = function storeDecision(groupId, request) {
  return axios.post("/groups/" + groupId + "/decisions", request);
};

var updateDecision = function updateDecision(groupId, decisionId, request) {
  return axios.put("/groups/" + groupId + "/decisions/" + decisionId, request);
};

var destroyDecision = function destroyDecision(groupId, decisionId) {
  return axios.delete("/groups/" + groupId + "/decisions/" + decisionId);
};

export { getMeetingsWithDecisions, getMeetingDecisions, storeDecision, updateDecision, destroyDecision };